import moment from "moment";
import {getColorFromForecast, getWarningIconFromForecast} from "./calendar";
import Axios from "axios";
import {toUrl} from "../../helpers/url";
import {handleAjaxSuccess} from "../../helpers/SwalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

let modal = null;

let callback = null;

function displayManageWeatherModal(forecast, date, projectId) {

	modal = document.querySelector('.manage-weather-modal');

	$(modal).modal('show');

	const momentDate = moment(date);

	const dateElement = modal.querySelector('.date');
	dateElement.innerText = momentDate.format('LL');

	const weatherIconElement = modal.querySelector('.weather-icon');
	const weatherDescriptionElement = modal.querySelector('.weather-description');

	const messageIconElement = modal.querySelector('.message-icon');
	const messageDescriptionElement = modal.querySelector('.message');

	// Clear up existing message
	messageIconElement.innerHTML = '';
	messageDescriptionElement.innerHTML = '';

	// Setup buttons handlers
	const ignoreWeatherButton = modal.querySelector('.ignore-weather-button');
	const markAsRainyDayButton = modal.querySelector('.mark-as-rainy-day-button');

	ignoreWeatherButton.onclick = () => ignoreWeather(forecast, projectId, date);
	markAsRainyDayButton.onclick = () => markAsRainyDay(forecast, projectId, date);

	// Hide buttons
	[ignoreWeatherButton, markAsRainyDayButton].forEach(button => button.classList.add('d-none'));

	if (forecast) {
		weatherIconElement.innerHTML = `
			<i
				class="mdi ${forecast.icon}"
				style="color: ${getColorFromForecast(forecast)}"
			></i>
		`;
		weatherDescriptionElement.innerText = forecast.title;

		let warningIcon = getWarningIconFromForecast(forecast);

		if (warningIcon) {
			messageIconElement.innerHTML = warningIcon;
			messageDescriptionElement.innerHTML = 'Weather may cause disruptions';

			// noinspection JSUnresolvedVariable
			if (forecast.forced_bad_weather) {
				messageDescriptionElement.innerHTML = 'Date was manually marked as rainy day';
			}

			// noinspection JSUnresolvedVariable
			if (forecast.ignored) {
				messageDescriptionElement.innerHTML = 'Forecast will be ignored';
			}
		}

		// noinspection JSUnresolvedVariable
		if (forecast.causes_disruption) {
			ignoreWeatherButton.classList.remove('d-none');
		} else {
			markAsRainyDayButton.classList.remove('d-none');
		}

	} else {
		weatherIconElement.innerHTML = `
			<i
				class="mdi mdi-weather-sunny"
				style="color: #ffc107"
			></i>
		`;
		weatherDescriptionElement.innerText = 'Clear Day';
		markAsRainyDayButton.classList.remove('d-none');
	}
}

function ignoreWeather(forecast, projectId, date) {
	setWeather(projectId, {
		date: date,
		ignoreBadWeather: true,
	}, forecast)
}

function markAsRainyDay(forecast, projectId, date) {
	setWeather(projectId, {
		date: date,
		markAsBadWeather: true,
	}, forecast)
}

function setWeather(projectId, data) {
	loading();
	Axios.post(toUrl(`/admin/projects/calendar/${projectId}/set-weather`), data)
		.then(response => handleAjaxSuccess(response, () => {
			// noinspection JSUnresolvedVariable
			const forecast = response.data.forecast;

			// noinspection JSUnresolvedVariable
			if (window.forecasts) {
				// Update global forecast array with new forecast
				const forecastDate = forecast.date.split(' ')[0];

				window.forecasts[forecastDate] = forecast;
			}

			// Call callback if exists
			if (callback) {
				callback();
			}

			$(modal).modal('hide');
		}))
		.catch(handleAjaxError)
		.finally(stopLoading)
}

/**
 * Sets a callback for after successful weather update
 * @param _callback
 */
function setManageWeatherCallback(_callback) {
	callback = _callback;
}

export {displayManageWeatherModal, setManageWeatherCallback}
